module.exports = __webpack_public_path__ + "static/box.15661699.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/img/box.png
// module id = 787
// module chunks = 146230036245944